<template>
  <div class="page">
    <div class="banner-wrap">
      <div class="banners">
        <img src="../assets/img/about/about_banner.jpg" alt="关于我们" />
      </div>
    </div>
    <div class="container-no">
      <!-- 大吕网络简介 -->
      <div class="dalv">
        <div class="logo">
          <img src="../assets/img/dalv-logo.png" alt="大吕网络" />
        </div>
        <div class="intro">
          <p>
            大吕网络成立于2017年，总部位于福建省福州市，企业覆盖北京、澳门（珠海横琴）、厦门、上海等城市，业务聚焦AI算力服务、数字营销、游戏开发 / 发行、MCN 机构运营、IP 品牌开发五大核心业务，长期与字节跳动、快手、阿里巴巴、NBA中国等多个头部平台与品牌保持紧密的业务合作关系。荣获2025 年度福建省数字经济核心产业创新企业“未来独角兽”，曾荣获“福建省最具成长性文化企业”，“福建省科技型中小企业”，福建省互联网企业综合实力评价50强”等荣誉称号。
          </p>
          <p>
            公司致力于成为一家国内领先的数字娱乐内容提供商与AI算力服务/数字营销服务商，通过能力、资源、资本联动打造一家国内领先的泛娱乐数字内容发行平台，为更广泛的用户提供优质的数字娱乐内容及IP产品，通过流量赋能为客户提供全方位AI算力/数字营销服务，为客户和合作伙伴创造更大的价值。
          </p>
          <p></p>
        </div>
      </div>
      <!-- 发展历程 -->
      <div class="develop">
        <h4>发展历程</h4>
        <p>development history</p>
        <div class="course">
          <div class="course-item1">
            <div class="item1">
              <h6>2016.12</h6>
              <p>
                大吕网络成立位于福建福州组建游戏发行、游戏运营、平台开发团队
              </p>
            </div>
            <div class="icon-wrap">
              <div class="wrap">
                <span>出发</span>
              </div>
            </div>
            <div class="item2">
              <h6>2017.3</h6>
              <p>
                成为字节跳动广告商业化合作伙伴，涉及数字营销业务，为流量主和品牌主提供全方位服务
              </p>
            </div>
          </div>
          <div class="course-item2">
            <div class="item1">
              <h6>2018.3</h6>
              <p>发行首款东方玄幻动作手游产品《九州行》</p>
            </div>
            <div class="icon-wrap">
              <div class="wrap">
                <span>前进</span>
              </div>
            </div>
            <div class="item2">
              <h6>2019.5</h6>
              <p>
                启动抖音MCN业务，并迅速成为抖音休闲游戏榜TOP1，累计粉丝超过1.3亿+；合作游戏伙伴数量超130+
              </p>
            </div>
          </div>
          <div class="course-item1">
            <div class="item1">
              <h6>2019.11</h6>
              <p>荣获国家高新技术企业认证、福建省高新技术企业认证</p>
            </div>
            <div class="icon-wrap">
              <div class="wrap">
                <span>发展</span>
              </div>
            </div>
            <div class="item2">
              <h6>2020.3</h6>
              <p>成立厦门火吖科技有限公司，布局抖音短视频直播电商</p>
            </div>
          </div>
          <div class="course-item2">
            <div class="item1">
              <h6>2020.4</h6>
              <p>入选福建省数字经济“瞪羚”创新企业</p>
            </div>
            <div class="icon-wrap">
              <div class="wrap">
                <span>创新</span>
              </div>
            </div>
            <div class="item2">
              <h6>2020.5</h6>
              <p>
                参与“消费扶贫，青春助力”直播公益项目，打开滞销农产品销售新出路
              </p>
            </div>
          </div>
          <div class="course-item1">
            <div class="item1">
              <h6>2021.4</h6>
              <p>
                大吕网络及旗下巨芯科技双双入选2021年全省数字经济领域“瞪羚”创新企业
              </p>
            </div>
            <div class="icon-wrap">
              <div class="wrap">
                <span>成长</span>
              </div>
            </div>
            <div class="item2">
              <h6>2021.5</h6>
              <p>成立趣读文化事业部，全面开启青少年教育内容板块业务</p>
            </div>
          </div>
          <div class="course-item2">
            <div class="item1">
              <h6>2021.8</h6>
              <p>大吕荣获福建省最具成长性文化企业</p>
            </div>
            <div class="icon-wrap">
              <div class="wrap">
                <span>突破</span>
              </div>
            </div>
            <div class="item2">
              <h6>2021.9</h6>
              <p>大吕荣获福建省科技型中小企业</p>
            </div>
          </div>
          <div class="course-item1">
            <div class="item1">
              <h6>2021.12</h6>
              <p>
                2021福建省互联网企业综合实力评价50强
              </p>
            </div>
            <div class="icon-wrap">
              <div class="wrap">
                <span>创举</span>
              </div>
            </div>
            <div class="item2">
              <h6>2022.7</h6>
              <p>大吕巨芯荣获科技小巨人，瞪羚企业</p>
            </div>
          </div>
          <!-- <div class="course-item1">
            <div class="item1 item-last">
              <h6>2021.12</h6>
              <p>2021福建省互联网企业综合实力评价50强</p>
            </div>
          </div> -->
        </div>
      </div>
      <!-- 荣誉奖项 -->
      <div class="honor">
        <h4>荣誉奖项</h4>
        <p>Honorary awards</p>
        <div class="content-wrap">
          <div class="carousel swiper-container">
            <div class="carousel-body swiper-wrapper">
              <div
                v-for="(item, index) in honor"
                :key="index"
                class="swiper-slide carousel-box"
              >
                <div class="slide-item">
                  <div class="item">
                    <div class="img-wrap">
                      <img :src="item.icon1" alt="荣誉奖项" />
                    </div>
                    <p v-text="item.name1"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mcn-scrollbar">
              <div class="swiper-scrollbar" style="transition-duration: 0ms">
                <div
                  class="swiper-scrollbar-drag"
                  style="
                    transform: translate3d(0px, 0px, 0px);
                    background: rgb(182, 182, 182);
                    width: 1rem;
                    transition-duration: 0ms;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {
      honor: [
      {

        icon1: require("../assets/img/about/honor/honor28.png"),
          name1: "2023年度抖音直播小玩法-磐石奖",
        },
        {
          icon1: require("../assets/img/about/honor/honor26.png"),
          name1: "2023年度福建省数字经济核心产业“瞪羚”创新企业-大吕",
        },
        {
          icon1: require("../assets/img/about/honor/honor27.png"),
          name1: "2023年度福建省数字经济核心产业“瞪羚”创新企业-巨芯",
        },
        {
          icon1: require("../assets/img/about/honor/honor19.png"),
          name1: "2022年福建省科技小巨人领军企业-大吕",
        },
        {
          icon1: require("../assets/img/about/honor/honor20.png"),
          name1: "2022年福建省科技小巨人领军企业-巨芯",
        },
        {
          icon1: require("../assets/img/about/honor/honor21.png"),
          name1: "2022年大吕高新技术企业",
        },
        {
          icon1: require("../assets/img/about/honor/honor22.png"),
          name1: "2021年巨芯高新技术企业",
        },
        {
          icon1: require("../assets/img/about/honor/honor3.png"),
          name1: "大吕-福建省数字经济领域“瞪羚”创新企业",
        },
        {
          icon1: require("../assets/img/about/honor/honor4.png"),
          name1: "2020年度十佳MCN机构",
        },
        {
          icon1: require("../assets/img/about/honor/honor5.png"),
          name1: "2020中国直播电商金播奖",
        },
        {
          icon1: require("../assets/img/about/honor/honor6.png"),
          name1: "2021年福建省互联网协会会员单位",
        },
        {
          icon1: require("../assets/img/about/honor/honor7.png"),
          name1: "江西神起2019年度十佳渠道商",
        },
        {
          icon1: require("../assets/img/about/honor/honor8.png"),
          name1:
            "荣获dou说家乡美-抖音区域创作者大会“抖音2019区域创作者合作机构”称号",
        },
        {
          icon1: require("../assets/img/about/honor/honor9.png"),
          name1: "巨芯-福建省数字经济领域“瞪羚”创新企业",
        },
        {
          icon1: require("../assets/img/about/honor/honor10.png"),
          name1: "巨量引擎广告代理",
        },
        {
          icon1: require("../assets/img/about/honor/honor11.png"),
          name1: "福建省科技型中小企业",
        },
        {
          icon1: require("../assets/img/about/honor/honor12.png"),
          name1:
            "2019巨量引擎“THINK  BIG  AWARDS”颁奖盛典“年度城市商业合作伙伴",
        },
        {
          icon1: require("../assets/img/about/honor/honor13.png"),
          name1: "2019腾讯优秀城市团队",
        },
        {
          icon1: require("../assets/img/about/honor/honor14.png"),
          name1: "2019巨量引擎福建KA双月PK优秀团队",
        },
        {
          icon1: require("../assets/img/about/honor/honor15.png"),
          name1: "龙岩军团感谢信",
        },
        {
          icon1: require("../assets/img/about/honor/honor16.png"),
          name1: "巨量引擎”亿发千钧“11月PK优秀团队",
        },
        {
          icon1: require("../assets/img/about/honor/honor17.png"),
          name1: "2021年福建最具成长性文化企业",
        },
        {
          icon1: require("../assets/img/about/honor/honor18.png"),
          name1: "2021福建省互联网企业综合实力评价50强",
        },
        {
          icon1: require("../assets/img/about/honor/honor23.png"),
          name1: "大吕-数字经济高成长性企业",
        },
        {
          icon1: require("../assets/img/about/honor/honor24.png"),
          name1: "巨芯-数字经济高成长性企业",
        },
        {
          icon1: require("../assets/img/about/honor/honor25.png"),
          name1: "首届福建省网信产业联合会-理事",
        }
        
      ],
      pages: "5",
      bannerUrl: null,
    };
  },
  created(){
      // let that = this;
      // this.$ajax
      //   .post("/banners/" + this.pages)
      //   .then(function (res) {
      //     console.log(res);
      //     that.bannerUrl = res.banners[0].imgurl;
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
  },
  mounted(){
    this.init();
  },
  methods: {
    init() {
      var swiper = new Swiper(".swiper-container", {
        pagination: ".swiper-pagination",
        autoplay: 5000,
        // autoplayDisableOnInteraction: false,
        slidesPerView: 1,
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        scrollbarDraggable: true,
        scrollbarSnapOnRelease: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        // spaceBetween: 42,

      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
// banner图


.dalv,.develop{
  padding: 0 15px;
}
// 大吕网络简介
.dalv {
  padding: 1rem;

  .logo {
    width: 45%;
    max-width: 260px;
    margin: 0 auto;
    margin-bottom: 1rem;
  }
  .intro {
    p {
      font-family: "Trebuchet MS", Helvetica, sans-serif;
      font-weight: 400;
      color: #333;
      margin-bottom: 0.5rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

// 发展历程
.develop {
  padding-top: 3rem;
  > h4,
  > p {
    text-align: center;
    letter-spacing: 1px;
  }
  > p {
    margin-bottom: 2rem;
  }
  .course {
    $padding: 2.1%;
    position: relative;
    .course-item1,
    .course-item2 {
      display: flex;
      justify-content: center;
      margin-bottom: 1rem;
      .item1,
      .item2 {
        display: flex;
        flex-direction: column;
        width: 42%;
        padding-top: 1%;
      }
      span {
        letter-spacing: 1px;
        font-size: .8rem;
      }
      p {
        padding-top: 8%;
        color: rgb(83, 83, 83);
      }
    }
    .course-item1 {
      .item1 {
        align-items: flex-end;
        padding-right: $padding;
        p {
          text-align: right;
        }
      }
      .item-last {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-right: 0 !important;
        p{
          text-align: center;

        }
      }
      .item2 {
        padding-left: $padding;
        p {
          text-align: left;
        }
      }
      h6 {
        width: 32%;
        text-align: center;
        color: #fff;
        background-color: rgb(178, 16, 16);
        padding: 3px 10px;
        border-radius: 20px;
        span {
          display: block;
        }
      }
      .icon-wrap {
        display: block;
        position: relative;
        padding: 10px;
        height: 100%;
        border-radius: 50%;
        border: 1px dashed rgb(178, 16, 16);
        opacity: 0.6;
        &:hover {
          opacity: 1;
          transform: scale(1.2);
          // animation: rotate 1s ease-in-out;
        }
        > .wrap {
          width: 3rem;
          height: 3rem;
          border-radius: 50%;
          background-color: #ba0c15;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            display: block;
            font-weight: 700;
            color: #fff;
          }
        }
      }
    }
    .course-item2 {
      .item1 {
        align-items: flex-end;
        padding-right: $padding;
        p {
          text-align: right;
        }
      }
      .item2 {
        padding-left: $padding;
      }

      h6 {
        width: 32%;
        text-align: center;
        color: #fff;
        background-color: #999;
        padding: 3px 10px;
        border-radius: 20px;
        span {
          display: block;
        }
      }

      .icon-wrap {
        display: block;
        position: relative;
        padding: 10px;
        height: 100%;
        border-radius: 50%;
        border: 1px solid #999;
        opacity: 0.6;
        &:hover {
          opacity: 1;
          transform: scale(1.2);
          // animation: rotate 1s ease-in-out;
        }
        > .wrap {
          width: 3rem;
          height: 3rem;
          border-radius: 50%;
          background-color: #999;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            display: block;
            font-size: px2rem(20);
            font-weight: 700;
            color: #fff;
          }
        }
      }
    }
  }
}
.honor {
  padding-top: 3rem;
  > h4,
  > p {
    text-align: center;
    letter-spacing: 1px;

  }
  > p {
    margin-bottom: 2rem;
  }
  > .content-wrap {
    width: 100%;
    .swiper-slide{
      // width: 300px !important;
      height: auto;
    }
    .item{
      .img-wrap{
        width: 310px;
        margin: 0 auto .5rem;
      }
      p{
        text-align: center;
        width: 75%;
        margin: 0 auto;
      }
    }
  }
}

.mcn-scrollbar {
  margin: 0px auto 2rem;
  width: 280px;
  height: .6rem;
  background-color: #f6f6f6;
  .swiper-scrollbar {
    width: 100%;
    height: 100%;
    background: #f8f8f8;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/us.vue